<template>
  <div class="text-block py-16" :class="[model.background]">
    <div class="container mx-auto max-w-screen-xl">
      <VcTypography :tag="model.heading" v-if="model.title" class="mb-4">{{ model.title }}</VcTypography>
      <iframe
        id=""
        title="yt-video"
        class="aspect-video h-full w-full"
        type="text/html"
        :src="model.videoUrl"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>
